import React from "react";
import Icon from "@ant-design/icons";

const UserSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill={fill}
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M18.7491 15.0005C18.7491 8.78728 23.7859 3.75049 29.9991 3.75049C36.2123 3.75049 41.2491 8.78728 41.2491 15.0005C41.2491 21.2137 36.2123 26.2505 29.9991 26.2505C23.7859 26.2505 18.7491 21.2137 18.7491 15.0005Z"
				fill="#344054"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.37723 50.2638C9.57058 39.0394 18.7291 30.0005 29.9991 30.0005C41.2694 30.0005 50.4281 39.0398 50.621 50.2646C50.6338 51.009 50.2049 51.6905 49.5283 52.001C43.5809 54.73 36.9654 56.2505 29.9999 56.2505C23.0338 56.2505 16.4177 54.7297 10.4699 52.0002C9.79325 51.6897 9.36441 51.0082 9.37723 50.2638Z"
				fill="#344054"
			/>
		</svg>
	);
};
const UserIcon = (props) => <Icon component={() => <UserSvg {...props} />} />;

export default UserIcon;
